import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from "react-router-dom";
import SignInForm from "./SignInForm";
import ResetPassword from "./ResetPassword";
import { logInUser, resetUserPassword } from "../services/SeekerServices";

const SeekerSignIn = ( props ) => {
    const [loginError, setLoginError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showSigninForm, setshowSigninForm] = useState(true);
    const [resetSuccess, setResetSuccess] = useState("");
    const [resetError, setResetError] = useState("");

    const onCloseModal = () => {
        props.setShowSignin(false);
    }

    const handleRedirect = (loginResponse) => {
        if (loginResponse.response === "success") {
    		onCloseModal();
    		props.setLoggedIn(true);
        } else {
            setLoginError(loginResponse.message);
        }
        setIsLoading(false);
    }

    const handleFormSubmit = (event) => {
    	event.preventDefault();
    	let data = {};
        data['email'] = data['username'] = event.target.email.value;
        data['password'] = event.target.password.value;
        setIsLoading(true);
        logInUser(data).subscribe(
            (loginResponse) => {
                handleRedirect(loginResponse);
            }
        )
    }

    const handleFormReset = (event) => {
    	event.preventDefault();
    	let data = {};
    	data['email'] = event.target.email.value;
        resetUserPassword(data).subscribe(
            (resetResponse) => {
                if (resetResponse.response === "success") {
                    setResetSuccess(resetResponse.message);
                    setResetError("");
                } else {
                    setResetError(resetResponse.message);
                    setResetSuccess("");
                }
                setIsLoading(false);
            }
        )
    }

	const showRegOverlay = () => {
		props.setShowSignin(false);
	    props.setShowRegOverlay(true);
	}

    return (
        <Modal isOpen={true} className="rounded_modal" toggle={onCloseModal} backdrop="static" keyboard={true} >
            <button type="button" onClick={onCloseModal} className="close modalClose" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <ModalHeader>{showSigninForm ? 'Job Seeker Sign In' : 'Forgot your password?'}</ModalHeader>
            <ModalBody>
                {showSigninForm &&
                    <React.Fragment>
                        <SignInForm onSubmit={handleFormSubmit} loginError={loginError} isLoading={isLoading} />
                    </React.Fragment>
                }
                {!showSigninForm &&
                    <React.Fragment>
                        <ResetPassword onSubmit={handleFormReset} initialValues={{creativeId: 72, siteId: 71}} resetError={resetError} resetSuccess={resetSuccess} />
                        <div className="text-center mt-2"><button className="btn btn-reset" onClick={() => setshowSigninForm(true)}>Back to Job Seeker Sign In</button></div>
                    </React.Fragment>
                }
            </ModalBody>
        </Modal>
    )

}

export default SeekerSignIn;
